import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';
import { Layout } from '../../types';

export interface LayoutFieldProps {
  control: Control<any>;
  layouts: Layout[];
  name: string;
}

const LayoutField = ({ control, layouts, name }: LayoutFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: { required: 'Please select a layout' } });

  useEffect(() => {
    if (field.value && !layouts.some(layout => layout.id === field.value)) {
      field.onChange('');
    }
    if (!field.value && layouts.length === 1) {
      field.onChange(layouts[0].id);
    }
  }, [layouts, field.value]);

  const getOptionLabel = optionId => layouts?.find(e => e.id === optionId)?.name ?? '';

  return (
    <Autocomplete
      data-cy="select-layout"
      clearOnBlur
      disabled={!layouts || layouts.length === 1}
      disableClearable
      getOptionLabel={getOptionLabel}
      handleHomeEndKeys
      renderOption={(props, optionId) => (
        <li {...props} key={optionId} data-cy={`select-option-${getOptionLabel(optionId)}`}>
          {getOptionLabel(optionId)}
        </li>
      )}
      options={(layouts ?? []).map(e => e.id)}
      renderInput={params => (
        <TextField {...params} label="Layout" error={!!error} helperText={error?.message} required />
      )}
      {...field}
      onChange={(event, option) => field.onChange(option)}
    />
  );
};

export default LayoutField;
